import { render, staticRenderFns } from "./TheTopNavbar.vue?vue&type=template&id=81e12042&"
import script from "./TheTopNavbar.vue?vue&type=script&lang=js&"
export * from "./TheTopNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports